/**
 * Learn More Ingredients — mobile carousel (1 card)
 * Desktop (≥750px) uses CSS grid; controls stay hidden.
 */
(function () {
  const MQ = window.matchMedia('(min-width: 750px)');

  function initCarousel(root) {
    const track = root.querySelector('[data-lm-ingredients-track]');
    const dotsWrap = root.querySelector('[data-lm-ingredients-dots]');
    const prev = root.querySelector('[data-lm-ingredients-prev]');
    const next = root.querySelector('[data-lm-ingredients-next]');
    if (!track) return;

    const slides = Array.from(track.children);
    if (slides.length < 2) return;

    let activeIndex = 0;
    let dots = [];

    function isDesktop() {
      return MQ.matches;
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function scrollToIndex(index, smooth) {
      if (isDesktop()) return;

      activeIndex = clampIndex(index);
      const slide = slides[activeIndex];
      if (!slide) return;

      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth',
      });
      updateUI();
    }

    function nearestIndex() {
      const scrollLeft = track.scrollLeft;
      let nearest = 0;
      let best = Infinity;

      slides.forEach(function (slide, index) {
        const delta = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
        if (delta < best) {
          best = delta;
          nearest = index;
        }
      });

      return clampIndex(nearest);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];

      if (isDesktop()) {
        dotsWrap.hidden = true;
        return;
      }

      dotsWrap.hidden = false;

      slides.forEach(function (_slide, index) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hormonize-learn-more-ingredients__dot';
        btn.setAttribute('aria-label', 'Go to ingredient ' + (index + 1));
        btn.addEventListener('click', function () {
          scrollToIndex(index);
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      });
    }

    function updateUI() {
      dots.forEach(function (dot, index) {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (prev) {
        prev.disabled = activeIndex <= 0;
      }
      if (next) {
        next.disabled = activeIndex >= slides.length - 1;
      }
    }

    function onScroll() {
      if (isDesktop()) return;
      activeIndex = nearestIndex();
      updateUI();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToIndex(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollToIndex(activeIndex + 1);
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    MQ.addEventListener('change', function () {
      buildDots();
      if (!isDesktop()) {
        scrollToIndex(0, false);
      } else {
        track.scrollLeft = 0;
        updateUI();
      }
    });

    buildDots();
    if (!isDesktop()) {
      scrollToIndex(0, false);
    } else {
      updateUI();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lm-ingredients]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
